import getOfficeSlug from './getOfficeSlug';
import getOfficesMarkers from './getOfficesMarkers';

export default function getOfficeBySlug(offices, slug, undergrounds) {
  return getOfficesMarkers([], offices, undergrounds).find(
    office => getOfficeSlug(office) === slug
  );
}
